import { render, staticRenderFns } from "./ContasInativar.vue?vue&type=template&id=551e8c3a"
import script from "./ContasInativar.vue?vue&type=script&lang=ts"
export * from "./ContasInativar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports